import React from 'react';
import './LoadingBar.css';

const LoadingBar = ({ fullScreen = false, tableCellMode = false }) => {
  return (
    <div className={`loading-container ${fullScreen ? 'full-screen' : ''} ${tableCellMode ? 'table-cell-loading' : ''}`}>
      <div className="loading-content">
        <div className="loading-bar">
          <div className="loading-bar-progress"></div>
        </div>
        {!tableCellMode && <div className="loading-text">Loading...</div>}
      </div>
    </div>
  );
};

export default LoadingBar;